import { render, staticRenderFns } from "./newFeatureModal.vue?vue&type=template&id=cd05c1f2&scoped=true&"
import script from "./newFeatureModal.vue?vue&type=script&lang=js&"
export * from "./newFeatureModal.vue?vue&type=script&lang=js&"
import style0 from "./newFeatureModal.vue?vue&type=style&index=0&id=cd05c1f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd05c1f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardText})
